import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { getRequest } from 'Includes/api/apicall';
import { GET_URL } from 'Includes/urls';
import { useNavigate } from 'react-router-dom';
function TaskUpdatesSprintList(props) {
  const navigate = useNavigate();
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const loadSprints = React.useCallback(() => {
    setLoading(true);
    getRequest(GET_URL.sprints.api, { limit: 500, pageno: 1 }, props)
      .then((response) => {
        if (response && response.status === 200) {
          setRows(response.data?.data || []);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [props]);

  React.useEffect(() => {
    loadSprints();
  }, [loadSprints]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700}>Task Updates</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select a sprint to enter daily updates for its date range.
      </Typography>
      <Paper sx={{ p: 2, borderRadius: 2 }}>
        <DataGrid
          autoHeight
          rows={rows}
          loading={loading}
          columns={[
            { field: 'name', headerName: 'Sprint', minWidth: 260, flex: 1 },
            { field: 'from_date', headerName: 'From Date', minWidth: 140, flex: 0.6 },
            { field: 'to_date', headerName: 'To Date', minWidth: 140, flex: 0.6 },
            {
              field: 'actions',
              type: 'actions',
              headerName: 'Actions',
              getActions: (params) => ([
                <GridActionsCellItem
                  label="Open Updates"
                  showInMenu
                  onClick={() => navigate(`/task/updates/${params.row.id}`)}
                />,
              ]),
            },
          ]}
          hideFooter
          disableRowSelectionOnClick
        />
      </Paper>
    </Box>
  );
}

export default TaskUpdatesSprintList;
